export default __webpack_public_path__ + "static/char-s-56-ja-05bb84d4a78b5ff9b870377ac6ea44f4.webp";